import { HashRouter, Switch, Route } from "react-router-dom";

import { TvPlanContextProvider } from "./contexts/tvplancontext";
import ChList from "./components/ChList";
import ChListByPackages from "./components/ChListByPackages";

import themes from "./themes.json";


function App() {
    const url = new URL((window.location.href||"").split("/").filter(v => ![ "#", "choose" ].includes(v)).join("/"));
    let app = url.pathname
        .replace(/^\/|\/$/g, '')
        .split("/")[0];
console.log(app);
    if (themes[app] == null) {
        app = "fa";
    }
console.log(app);

    if (undefined === themes[app]) {
        throw new Error('Theme does not found!');
    }

    if (undefined === themes[app].config) {
        throw new Error('Config is mandatory!');
    }

    if (undefined === themes[app].config.en) {
        throw new Error('English config is mandatory!');
    }
    // Set Favicon
    document.querySelector('link[rel="icon"]').href = themes[app].favicon;

    return (
        <HashRouter>
            <Switch>
                <Route key="ch-list" exact path="/:app?/list">
                    <ChList
                        theme={themes[app]}
                        urlParams={url?.searchParams||null}
                    />
                </Route>
                <Route key="list-by-package" exact path="/:app?/list-by-package">
                    <div className={`App ${themes[app].name}`}>
                        <ChListByPackages
                            theme={themes[app]}
                            urlParams={url?.searchParams||null}
                        />
                    </div>
                </Route>
                <Route key="app-landing" exact path="/:app?">
                    <div className={`App ${themes[app].name}`}>
                        <TvPlanContextProvider
                            theme={themes[app]}
                            urlParams={url?.searchParams||null}
                        />
                    </div>
                </Route>
            </Switch>
        </HashRouter>
    );
}

export default App;
